import { ReactElement, useMemo } from 'react'
import { BookTabProps } from './props'
import { DateCarousel, Grid } from '../../../../Molecules'
import { Button, Text } from '../../../../Atoms'

const BookTab = ({
    carouselRef,
    dates,
    onClickTimeSlot = () => undefined,
    timeSlots,
    timeText,
    ...props
}: BookTabProps): ReactElement => {
    const dateCarouselComponent = useMemo(
        () =>
            dates && (
                <DateCarousel dates={dates} ref={carouselRef} {...props} />
            ),
        [carouselRef, dates, props]
    )

    const timeSlotsComponent = useMemo(
        () =>
            timeSlots && (
                <Grid gap={4}>
                    <Text primary>{timeText}</Text>
                    <Grid
                        gap="8"
                        css={{
                            gridTemplateColumns:
                                'repeat(auto-fill, minmax(75px, 1fr))',

                            '@desktop': {
                                maxW: 550,
                            },
                        }}
                    >
                        {timeSlots.map(({ state, time }) => (
                            <Button
                                active={state === 'selected'}
                                data-cy={`timeslot_${time}`}
                                key={time}
                                onClick={() => onClickTimeSlot(time)}
                                size="large"
                                variant="option"
                            >
                                {time}
                            </Button>
                        ))}
                    </Grid>
                </Grid>
            ),
        [onClickTimeSlot, timeSlots, timeText]
    )

    return (
        <Grid gap="16" data-cy="modalBookTab">
            {dateCarouselComponent}
            {timeSlotsComponent}
        </Grid>
    )
}

export default BookTab
